"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = exports.RRPrevX = exports.HR_BPM = void 0;
const helpers_1 = require("../helpers");
const GraphMonitor_1 = require("./GraphMonitor");
const Pacer = __importStar(require("../UI/PacerPanel"));
const Ref = __importStar(require("../Presets/ReferenceDefaults"));
const SETTINGS = __importStar(require("../UI/SettingsPanel"));
const PACER = __importStar(require("../UI/PacerPanel"));
const DISPLAY = __importStar(require("../UI/DisplayPanel"));
const DisplayPanel_1 = require("../UI/DisplayPanel");
var SETTINGS_INPUTS = SETTINGS.INPUTS, PACER_INPUTS = PACER.INPUTS, DISPLAY_ELEMS = DISPLAY.DisplayNodes, SN_VAR = 0, AV_VAR = 0, QRS_VAR = 0, RPULSEX = 0, // latest x when R 
PPULSEX = 0, // latest x when P
APULSEX = 0, VPULSEX = 0, RRPrevX = 0, HR_BPM = 0;
exports.RRPrevX = RRPrevX;
exports.HR_BPM = HR_BPM;
function Init(id) {
    reset();
    DisplayPanel_1.nX.addEventListener("change", reset);
    SETTINGS_INPUTS = SETTINGS.INPUTS; //console.log(SETTINGS_INPUTS);
    let hrGraph = new GraphMonitor_1.GraphMonitor(id);
    hrGraph.Y = (x) => graphY(x, hrGraph);
}
exports.Init = Init;
function reset() {
    SN_VAR = 0;
    AV_VAR = 0;
    QRS_VAR = 0;
    RPULSEX = 0; // latest x when R 
    PPULSEX = 0; // latest x when P
    APULSEX = 0;
    VPULSEX = 0;
    exports.RRPrevX = RRPrevX = 0;
    exports.HR_BPM = HR_BPM = 0;
    SETTINGS_INPUTS = SETTINGS.INPUTS;
    PACER_INPUTS = PACER.INPUTS;
    DISPLAY_ELEMS = DISPLAY.DisplayNodes;
    //console.log("reset HR Graph VARS");
}
function updateDisplayHR(hr, DISPLAY_ELEMS) {
    let str = "--";
    if (hr > 0 && hr < 600) { // hotfix 
        str = hr.toString();
        exports.HR_BPM = HR_BPM = hr;
    }
    DISPLAY_ELEMS["hr_display_v"].textContent = str;
}
function graphY(x, hr_graph) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    const w = hr_graph.WIDTH, h = hr_graph.HEIGHT, dT = hr_graph.nDIVX, maxH_mV = 10; // y-axis in mV --> full h in px
    const dx = x % w;
    // Get values from page
    // settings vars
    const snr_bpm = Number((_a = SETTINGS_INPUTS['sn_r']) === null || _a === void 0 ? void 0 : _a.value);
    const avr_bpm = Number((_b = SETTINGS_INPUTS['av_r']) === null || _b === void 0 ? void 0 : _b.value);
    const p_h_mod = Number((_c = SETTINGS_INPUTS["p_h"]) === null || _c === void 0 ? void 0 : _c.value);
    const p_w_mod = Number((_d = SETTINGS_INPUTS["p_w"]) === null || _d === void 0 ? void 0 : _d.value);
    const pr_w_mod = Number((_e = SETTINGS_INPUTS["pr_w"]) === null || _e === void 0 ? void 0 : _e.value);
    const st_w_mod = Number((_f = SETTINGS_INPUTS['st_w']) === null || _f === void 0 ? void 0 : _f.value);
    const pr_h_mod = Number((_g = SETTINGS_INPUTS["pr_h"]) === null || _g === void 0 ? void 0 : _g.value); /*TODO? pr elevation*/
    const st_h_mod = Number((_h = SETTINGS_INPUTS['st_h']) === null || _h === void 0 ? void 0 : _h.value); /*TODO?* st elevation*/
    const t_w_mod = Number((_j = SETTINGS_INPUTS["t_w"]) === null || _j === void 0 ? void 0 : _j.value);
    const qrs_n = Number((_k = SETTINGS_INPUTS["qrs_n"]) === null || _k === void 0 ? void 0 : _k.value);
    const qrs_w_mod = Number((_l = SETTINGS_INPUTS["qrs_w"]) === null || _l === void 0 ? void 0 : _l.value);
    const qrs_h_mod = Number((_m = SETTINGS_INPUTS["qrs_h"]) === null || _m === void 0 ? void 0 : _m.value);
    const t_h_mod = Number((_o = SETTINGS_INPUTS["t_h"]) === null || _o === void 0 ? void 0 : _o.value);
    const s_h_mod = Number((_p = SETTINGS_INPUTS["s_h"]) === null || _p === void 0 ? void 0 : _p.value);
    const labels_cb = (_q = SETTINGS_INPUTS["labels"]) === null || _q === void 0 ? void 0 : _q.checked;
    // modifiers
    const pr_cb = ((_r = SETTINGS_INPUTS["pr_cb"]) === null || _r === void 0 ? void 0 : _r.checked) || false;
    const qrs_cb = ((_s = SETTINGS_INPUTS["qrs_cb"]) === null || _s === void 0 ? void 0 : _s.checked) || false;
    const snr_cb = ((_t = SETTINGS_INPUTS["snr_cb"]) === null || _t === void 0 ? void 0 : _t.checked) || false;
    const avr_cb = ((_u = SETTINGS_INPUTS["avr_cb"]) === null || _u === void 0 ? void 0 : _u.checked) || false;
    // pacer vars
    const ap_detect = PACER_INPUTS["ap_detect"];
    const as_detect = PACER_INPUTS["as_detect"];
    const vp_detect = PACER_INPUTS["vp_detect"];
    const vs_detect = PACER_INPUTS["vs_detect"];
    const pacer_bpm = Number(PACER_INPUTS["pacer_rate"].value);
    const aout_min = Number(SETTINGS_INPUTS["a_out_min"].value) || 0;
    const a_out_mA = Number((_v = PACER_INPUTS["a_out"]) === null || _v === void 0 ? void 0 : _v.value) || 0;
    const asense_mV = Number((_w = PACER_INPUTS["a_sense"]) === null || _w === void 0 ? void 0 : _w.value) || 0;
    const responsemode = Pacer.ResponseMode;
    const vout_min = Number(SETTINGS_INPUTS["v_out_min"].value) || 0;
    const v_out_mA = Number(PACER_INPUTS["v_out"].value) || 0;
    const vsense_mV = Number(PACER_INPUTS["v_sense"].value) || 0;
    // bpm --> bps --> pxps (pixels per second)
    const dx1ps = (60 / snr_bpm) * (w / dT) || 0, dx2ps = (60 / avr_bpm) * (w / dT) || 0, dx3ps = (60 / pacer_bpm) * (w / dT) || 0;
    //** INNATE RHYTHM **//
    const n1 = Math.floor(x / dx1ps) || 0, n2 = Math.floor(x / dx2ps) || 0;
    //n3 = Math.floor(x / dx3ps) || 0
    var p = 0, q = 0, r = 0, s = 0, t = 0;
    // default amplitudes
    let p_h = Ref.p.h * p_h_mod, q_h = Ref.q.h * qrs_h_mod, r_h = Ref.r.h * qrs_h_mod, s_h = Ref.s.h * s_h_mod, t_h = Ref.t.h * t_h_mod;
    let noise = Math.random() * 0.2 + 1;
    // default durations (seconds)
    let p_w = Ref.p.w * p_w_mod, q_w = Ref.q.w * qrs_w_mod, r_w = Ref.r.w * qrs_w_mod, s_w = Ref.s.w * qrs_w_mod, t_w = Ref.t.w * t_w_mod;
    let qrs_drop_counter = qrs_n > 0 ? n2 % (qrs_n + QRS_VAR) : n2 + 1;
    let drop = !(qrs_drop_counter > 0) ? 0 : 1;
    let pq_multiplier = pr_cb ? qrs_drop_counter : 1;
    let p_q_interval = Ref.pq.w * pr_w_mod * pq_multiplier;
    let p_i = (p_w / 2 + Ref.p.i) * (w / dT);
    let q_i = p_i + (p_w + q_w / 2 + p_q_interval) * (w / dT);
    let r_i = q_i + (q_w + r_w / 2 + Ref.r.i) * (w / dT);
    let s_i = r_i + (r_w + s_w / 2 + Ref.s.i * (w / dT));
    let t_i = s_i + (s_w + t_w / 2 + Ref.st.w * st_w_mod * (w / dT));
    let p_dx_max = p_i + n1 * dx1ps;
    // Innate P wave
    if (snr_bpm > 0) {
        // update params on new SN beat
        if (Math.floor((hr_graph.X - 1) / dx1ps) != n1) {
            // arrhythmia due to variable sn node rate +/- 25%
            SN_VAR = snr_cb ? 0.75 * dx1ps * Math.random() * 0.25 + 1 : 0;
        }
        ;
        p_dx_max = p_i + n1 * dx1ps + SN_VAR;
        p = (0, GraphMonitor_1.Pulse)(x, p_dx_max, p_h * noise, p_w * (w / dT));
        if (Math.floor(x - p_dx_max) == -5) {
            if (-p > 0) {
                if (labels_cb)
                    hr_graph.Label("p", dx, 50, 8);
                PPULSEX = x;
            }
            ;
        }
    }
    // Innate QRST
    let r_dx_max = 0;
    if (avr_bpm > 0) {
        // update params on new AV beat
        if (Math.floor((hr_graph.X - 1) / dx2ps) != n2) {
            // arrhythmia due to variable sn node rate +/- 25%
            AV_VAR = avr_cb ? 0.75 * dx2ps * Math.random() * 0.25 + 1 : SN_VAR;
            // drop qrs randomly based on qrs_n -- min qrs_n, max 2*qrs_n 
            QRS_VAR = qrs_cb ? (0, helpers_1.getRandomInt)(0, qrs_n) : 0; //console.log(qrs_drop_counter,drop);
        }
        ;
        r_dx_max = r_i + n2 * dx2ps + AV_VAR;
        q = (0, GraphMonitor_1.Pulse)(x, q_i + n2 * dx2ps + AV_VAR, q_h * noise * drop, q_w * (w / dT));
        r = (0, GraphMonitor_1.Pulse)(x, r_dx_max, r_h * noise * drop, r_w * (w / dT));
        s = (0, GraphMonitor_1.Pulse)(x, s_i + n2 * dx2ps + AV_VAR, s_h * noise * drop, s_w * (w / dT));
        t = (0, GraphMonitor_1.Pulse)(x, t_i + n2 * dx2ps + AV_VAR, t_h * drop, t_w * (w / dT));
        if (Math.floor(x - r_dx_max) == 0) {
            if (-r > 0) {
                if (labels_cb)
                    hr_graph.Label("r", dx, 30, 8);
                //console.log(r);
                RPULSEX = x;
            }
            ;
        }
    }
    //** PACER A PULSE & RESPONSE **//
    let pulse_i_dx = 5;
    let apace = !PACER_INPUTS["a_out"].disabled && pacer_bpm > 0; //@TODO - fail pace 
    let acapture = a_out_mA > 0 && a_out_mA >= aout_min; //@TODO - fail capture
    let asensing = !PACER_INPUTS["a_sense"].disabled && pacer_bpm > 0; //@TODO - fail sense 
    let asensitivity = p_h / h * maxH_mV > asense_mV;
    let asensed = apace && asensing
        && asensitivity && -p > 0
        && x - PPULSEX < dx3ps;
    // A Pulse	
    let a = 0, a_h = 20;
    as_detect.checked = false;
    ap_detect.checked = false;
    // start spike relative to p_i start
    let offseta = p_i - (5 * p_w) * (w / dT);
    if (x > offseta && apace && x >= dx3ps) {
        //console.log(p_h/h * maxH_mV, p_h, h, p_w, w, dT) ; 
        if (!asensing || !asensitivity) {
            // A pacing but not sensing
            if ((x - offseta) % dx3ps < pulse_i_dx) {
                ap_detect.checked = true;
                if ((x - offseta) % dx3ps < 1) {
                    a = a_h;
                    if (labels_cb)
                        hr_graph.Label("A", dx, 20);
                    //console.log("pacing");
                    APULSEX = x;
                }
            }
        }
        else { // a sensing
            if ((x - PPULSEX) % (dx3ps) < pulse_i_dx) {
                // inhibit if a sensed            
                if (asensed && (responsemode == 1 || responsemode == 3)) {
                    // atrial sensed (p)
                    as_detect.checked = true;
                    if ((x - PPULSEX) % (dx3ps) < 1 && labels_cb)
                        hr_graph.Label("as", dx, 120);
                }
                else {
                    ap_detect.checked = true;
                    if ((x - PPULSEX) % (dx3ps) < 1) {
                        a = a_h;
                        if (labels_cb)
                            hr_graph.Label("A", dx, 20);
                        APULSEX = x;
                    }
                }
            }
        }
    }
    // A Response Curves
    const doAResponse = apace && acapture && !asensed && APULSEX >= dx3ps;
    if (doAResponse) {
        p_i = APULSEX + 5;
        q_i = p_i + (p_w + q_w / 2 + p_q_interval) * (w / dT);
        r_i = q_i + (q_w + r_w / 2 + 0.02) * (w / dT);
        s_i = r_i + (r_w + s_w / 2 + 0.01) * (w / dT);
        t_i = s_i + (s_w + t_w / 2 + 0.20 * st_w_mod) * (w / dT);
        p = Math.floor(Math.abs(p)) == 0 ? (0, GraphMonitor_1.Pulse)(x, p_i, p_h, 0.01 * dx3ps) : p; //console.log(n3, Math.floor(p_i));
        // trigger innate qrst ?
        if (responsemode >= 1) {
            r_dx_max = r_i + AV_VAR;
            q = Math.floor(Math.abs(q)) == 0 ? (0, GraphMonitor_1.Pulse)(x, q_i + AV_VAR, q_h * noise * drop, q_w * (w / dT)) : q;
            r = Math.floor(Math.abs(r)) == 0 ? (0, GraphMonitor_1.Pulse)(x, r_i + AV_VAR, r_h * noise * drop, r_w * (w / dT)) : r;
            s = Math.floor(Math.abs(s)) == 0 ? (0, GraphMonitor_1.Pulse)(x, s_i + AV_VAR, s_h * noise * drop, s_w * (w / dT)) : s;
            t = Math.floor(Math.abs(t)) == 0 ? (0, GraphMonitor_1.Pulse)(x, t_i + AV_VAR, t_h * noise * drop, t_w * (w / dT)) : t;
            if (Math.floor(x - r_dx_max) == 0) {
                if (-r > 0) {
                    if (labels_cb)
                        hr_graph.Label("rt", dx, h - 15, 10);
                    //console.log(r);
                    RPULSEX = x + dx3ps;
                }
                ;
            }
        }
    }
    /** PACER V PULSE & RESPONSE **/
    const qrs_w = (q_w + r_w + s_w) * (4 * w / dT); //console.log(qrs_w);
    const delay = (responsemode >= 2 && doAResponse) ? qrs_w : 0;
    const offsetv = offseta + 9.5 * p_w * (w / dT);
    let vpacing = !PACER_INPUTS["v_out"].disabled && pacer_bpm > 0; //@TODO - fail to pace due to equipment
    let vcapture = v_out_mA > 0 && v_out_mA >= vout_min; //@TODO - fail to capture due to equipment
    let vsensing = !PACER_INPUTS["v_sense"].disabled; //@TODO - fail to vsense due to equipment
    let vsensitivity = r_h / h * maxH_mV > vsense_mV;
    let vsenseAtX = RPULSEX + delay;
    let vsensed = vsensing
        && vsensitivity
        && x < dx3ps + vsenseAtX;
    // V Pulse
    let v = 0, v_h = 40;
    vs_detect.checked = false;
    vp_detect.checked = false;
    if (x > offsetv && vpacing && x > dx3ps) {
        if (!vsensing || !vsensitivity) {
            // V pacing but not sensing
            if ((x - offsetv) % dx3ps < pulse_i_dx) {
                vp_detect.checked = true;
                if ((x - offsetv) % dx3ps < 1) {
                    v = v_h;
                    if (labels_cb)
                        hr_graph.Label("V", dx, 20);
                    VPULSEX = x;
                }
            }
        }
        else {
            if ((x - RPULSEX) % (dx3ps) < pulse_i_dx) {
                //console.log("v sensing", vsensing, vsensitivity, x-RPULSEX, dx3ps );
                if (vsensed && (responsemode == 1 || responsemode == 3)) {
                    // vent. activity sensed (r)
                    vs_detect.checked = true; //console.log("vsensed");
                    v = 0;
                    if ((x - RPULSEX) % (dx3ps) < 1 && labels_cb) {
                        hr_graph.Label("vs", dx, 130);
                    }
                }
                else {
                    vp_detect.checked = true;
                    if ((x - RPULSEX) % (dx3ps) < 1) {
                        v = v_h;
                        if (labels_cb)
                            hr_graph.Label("V", dx, 20);
                        VPULSEX = x;
                    }
                }
            }
        }
    }
    // V Response
    const doVResponse = vpacing && vcapture && !vsensed && VPULSEX >= dx3ps;
    let vr = 0;
    if (doVResponse) {
        // check if q, r, s, t are present
        if (VPULSEX > RPULSEX) {
            vr = Math.max(graphVResponse(x, VPULSEX + 5, dx3ps), r);
        }
    }
    else {
        //vr = 0;
        //console.log(`no v response:`, `vpacing: ${vpacing}`, `vcapture: ${vcapture}`, `vsensed: ${vsensed}`, `VPULSEX: ${VPULSEX}`, `dx3ps: ${dx3ps}`);
    }
    // a - pacer a pulse
    // p - innate p wave
    // v - pacer v pulse
    let y = a + p + v + q + r + s + t + vr;
    // Update R-R interval, HR
    let bpm = avr_bpm;
    //HR_BPM = HR_BPM==0? bpm : HR_BPM;
    if ((x == RPULSEX || x == VPULSEX)
        && (RPULSEX > 0 || VPULSEX > 0)) {
        let deltaRRx = x == RPULSEX ? RPULSEX - RRPrevX : VPULSEX - RRPrevX;
        //console.log(x, deltaRRx, VPULSEX, RPULSEX, RRPrevX);
        if (deltaRRx > 10) {
            bpm = RRPrevX > 0 ? (60 / ((deltaRRx) * dT / w)) : bpm;
            updateDisplayHR(Math.round(bpm), DISPLAY_ELEMS);
            exports.RRPrevX = RRPrevX = x == RPULSEX ? RPULSEX : VPULSEX;
        }
    }
    return Math.min(y + h / 2, h);
}
/* Innate signals */
function graphP(x, xi, rate_dx) {
    const p_h_mod = Number(SETTINGS_INPUTS["p_h"].value);
    const noise = Math.random() * 0.2 + 1;
    const p_h = Ref.p.h * p_h_mod;
    const p_w = Ref.p.w;
    const p_i = (p_w / 2 + Ref.p.i);
    let p = 0;
    // Innate P wave
    p = (0, GraphMonitor_1.Pulse)(x, p_i + PPULSEX, p_h * noise, p_w);
    return p;
}
/* Pacer signals */
function graphVResponse(x, xi, rate_dx) {
    const r_h = -50, r_w = 0.04 * rate_dx, r_i = xi;
    const t_h = 25, t_w = 0.08 * rate_dx, t_i = r_i + 2 * t_w;
    const r = (0, GraphMonitor_1.Pulse)(x, r_i, r_h, r_w);
    const t = (0, GraphMonitor_1.Pulse)(x, t_i, t_h, t_w);
    let y = r + t;
    return y;
}
